import React from "react";
import { RCCGrid, RCCIcon, RCCPopover } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IChartIndicatorsTitle } from "./interface";

const ChartIndicatorsTitle: React.FC<IChartIndicatorsTitle> = ({
	title,
	hideEvaluationForm,
	evaluationForm,
	method,
	descObjective,
	measureUnit
}) => {
	const { translate } = useTranslation();
	return(
		<>
			<Title size="lg" color="purple" bold>
				{title}
				<div  style={{ marginLeft: "4px" }}>
					{!hideEvaluationForm && (
						<RCCPopover
							header={{title: `${translate("Método de avaliação")} 
        (${evaluationForm === 0 ? translate("Melhor para baixo") : translate("Melhor para cima")})
            `}}
							body={{text: method || "" }}
							position="rightEnd"
						>
							<RCCIcon
								name={evaluationForm === 0 ? "arrowDown" : "arrowUp"}
								size={24}
								color="var(--purple-lighter)"
								style={{
									border: "2px solid var(--purple-lighter)",
									borderRadius: "50%"
								}}
							/>
						</RCCPopover>
					)}
				</div>
			</Title>
			<RCCGrid container item alignItems="center" justifyContent="center" >
				{descObjective !== null && descObjective !== "" && (
					<Title size="sm" color="purple" >{descObjective}</Title>
				)}
				{measureUnit !== null && measureUnit !== "" && (
					<Title size="sm" color="purple">{translate("Unidade de medida")}: {measureUnit}</Title>
				)}
			</RCCGrid>
		</>
	);};

export default ChartIndicatorsTitle;
